import { Suspense, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { RouterProvider } from 'react-router';

import { useClearStateOnSessionEnd } from './hooks/useClearStateOnSessionEnd';
import { useDocumentTitleRenderer } from './hooks/useDocumentTitleRenderer';
import { BootFallback } from './Layout/AppShell';
import { AppRoutes } from './routes';

const stylesheet = {
  container: 'xl:mx-auto font-roboto bg-semantic-bg-page',
};

export function App() {
  const { t } = useTranslation();
  useDocumentTitleRenderer();
  useClearStateOnSessionEnd();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const router = useMemo(() => AppRoutes(), []);

  return (
    <>
      <meta name="description" content={t('meta.description')} />
      <div className={stylesheet.container}>
        <Suspense fallback={<BootFallback />}>
          <RouterProvider router={router} />
        </Suspense>
      </div>
    </>
  );
}
